import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { TabCustomFieldsComponent } from './tab-custom-fields.component';

@NgModule({
  declarations: [
    TabCustomFieldsComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,

    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatSelectModule,
    MatDatepickerModule
  ],
  exports: [
    TabCustomFieldsComponent
  ]
})
export class TabCustomFieldsModule { }
